import React, { useEffect, useRef, useState } from "react";

const WHATSAPP_NUMBER = "5491130080021"; // solo dígitos, sin '+'
const PRESET_TEXT = "¡Hola Frente Ya! Quiero ser Ya!";
const IDLE_MS = 30000;   // 30s sin actividad → mostrar burbuja
const SHOW_BUBBLE_MS = 8000;
const STORAGE_KEY = "fy_wa_hint_shown";

export const WhatsAppButton = () => {
  const [show, setShow] = useState(false);
  const [hint, setHint] = useState(false);
  const idleTimer = useRef(null);
  const hintTimer = useRef(null);

  // Aparece tras un pequeño delay
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 1500);
    return () => clearTimeout(t);
  }, []);

  // Hint anti-bounce: tras 30s sin scroll/mouse, mostrar burbuja una vez por sesión
  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    const resetIdle = () => {
      if (idleTimer.current) clearTimeout(idleTimer.current);
      idleTimer.current = setTimeout(() => {
        setHint(true);
        sessionStorage.setItem(STORAGE_KEY, "1");
        hintTimer.current = setTimeout(() => setHint(false), SHOW_BUBBLE_MS);
      }, IDLE_MS);
    };

    const events = ["mousemove", "scroll", "keydown", "touchstart"];
    events.forEach((e) => window.addEventListener(e, resetIdle, { passive: true }));
    resetIdle();

    return () => {
      events.forEach((e) => window.removeEventListener(e, resetIdle));
      if (idleTimer.current) clearTimeout(idleTimer.current);
      if (hintTimer.current) clearTimeout(hintTimer.current);
    };
  }, []);

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PRESET_TEXT)}`;

  return (
    <div
      className={`fixed bottom-5 left-5 sm:bottom-7 sm:left-7 z-40 transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      {/* Burbuja anti-bounce */}
      <div
        aria-hidden={!hint}
        className={`absolute left-full ml-3 bottom-1/2 translate-y-1/2 whitespace-nowrap transition-all duration-300 ${
          hint ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-2 pointer-events-none"
        }`}
      >
        <div className="relative bg-white border border-[#0A192F]/15 shadow-xl px-4 py-2.5 rounded-2xl rounded-bl-sm">
          <div className="text-xs font-headings text-[#0A192F] uppercase tracking-wide">
            ¿Necesitás ayuda?
          </div>
          <div className="text-[11px] text-[#4B5563]">Escribinos por WhatsApp ✦</div>
          <button
            type="button"
            onClick={() => setHint(false)}
            className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-[#0A192F] text-white text-[10px] flex items-center justify-center hover:bg-[#0A2463]"
            aria-label="Cerrar"
            data-testid="wa-hint-close"
          >
            ×
          </button>
        </div>
      </div>

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp · Quiero ser Ya!"
        data-testid="whatsapp-fab"
        className="group relative inline-block"
      >
        {/* Pulse ring */}
        <span
          aria-hidden
          className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping"
          style={{ animationDuration: "2.8s" }}
        />
        <div className="relative inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white pl-3 pr-4 sm:pl-3 sm:pr-5 py-3 rounded-full shadow-2xl shadow-emerald-900/30 transition-all">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden>
            <path d="M.057 24l1.687-6.163A11.867 11.867 0 010 11.971C0 5.367 5.367 0 11.971 0c3.196 0 6.197 1.244 8.456 3.503a11.82 11.82 0 013.503 8.474c0 6.604-5.367 11.971-11.971 11.971-1.99 0-3.946-.5-5.682-1.448L.057 24zm6.597-3.807c1.676.995 3.272 1.591 5.323 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.886-.001 2.166.635 3.791 1.704 5.49l-.999 3.648 3.853-1.038zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.296-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413z"/>
          </svg>
          <span className="hidden sm:inline font-headings uppercase tracking-wide text-sm whitespace-nowrap">
            Quiero ser Ya!
          </span>
        </div>
      </a>
    </div>
  );
};

export default WhatsAppButton;
